import React from 'react';
import ProductAdvertising from '../../../components/ProductAdvertising';
import { useIntl } from 'react-intl';

const Slidein = () => {

    const textTranslator = useIntl();

    const data = {
        id: 32,
        id_en: 335,
        context: 'slidein',
        title: textTranslator.formatMessage({ id: 'products.blocs.slidein' })
    }
    return (
        <div>
            <ProductAdvertising data={data} />
        </div>
    );
};

export default Slidein;